/**
 * Render a JSON-LD `<script>` for schema.org structured data.
 *
 * SSR-visible: it is rendered into the page HTML (not injected client-side), so
 * crawlers see it without executing JavaScript. Render one per structured-data
 * object (WebSite, SoftwareApplication, BreadcrumbList, …).
 *
 * The serialized JSON is escaped (`<`, `>`, `&` → `\u00XX`) before being placed
 * inside a `<script>` tag. This prevents a `</script>` substring in any data
 * value (e.g. a tool description) from breaking out of the script context — a
 * standard JSON-in-HTML XSS mitigation. The escapes are valid JSON, so parsers
 * (incl. Google's structured-data parser) decode them back transparently.
 */
export function JsonLd({ data }: { data: object }) {
  const json = JSON.stringify(data)
    .replace(/&/g, '\\u0026')
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e');
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}
